<script setup>
/**
 * FormDisplayTitle
 * Renders a breadcrumb navigation showing the parent component name and the
 * specific record title. Resolves the display title using the component's nameField.
 */
import { computed, getCurrentInstance } from 'vue';
import Button from "../Button.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const formState = computed(() => store.state[props.formId]);

const tableName = computed(() => formState.value?.tableName);

const originalData = computed(() => formState.value?.originalData);

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === tableName.value);
});

const componentId = computed(() => store.state.components.componentIds[tableName.value]);

const nameField = computed(() => store.getters['components/nameField'](componentId.value));

const title = computed(() => originalData.value ? originalData.value[nameField.value] : '');

const showTitle = computed(() => {
    return tableName.value !== 'account_settings' && title.value;
});

// --- Methods ---

const goToListing = () => {
    proxy.$router.push({
        name: 'list',
        params: {
            component: tableName.value
        },
        // Maintains current query params (e.g., product filters/IDs)
        query: proxy.$route.query
    });
};
</script>

<template>
    <span class="ms-1 d-inline-flex align-items-center small text-nowrap">
        <Button class="btn-sm lh-1 me-1 p-1" @click.native="goToListing">
            <small>{{ component?.title }}</small>
        </Button>

        <template v-if="showTitle">
            <i class="bi-chevron-compact-right"/>
            <small class="px-2 text-truncate">{{ title }}</small>
        </template>
    </span>
</template>

<style scoped>
.text-truncate {
    max-width: 200px;
}

@media (min-width: 768px) {
    .text-truncate {
        max-width: inherit;
    }
}
</style>